var _excluded = ["height", "width"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

var IconIllustrativeRecommendation = function IconIllustrativeRecommendation(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9 4.1C25.011 1.15 20.506.03 16 0 11.494.03 6.99 1.151 4.1 4.1 1.15 6.99.03 11.494 0 16c.03 4.506 1.151 9.011 4.1 11.9C6.989 30.85 11.494 31.97 16 32c4.506-.03 9.01-1.151 11.9-4.1 2.949-2.89 4.07-7.394 4.1-11.9-.03-4.506-1.151-9.011-4.1-11.9z",
    fill: "#FF5056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.384 26.096A11.122 11.122 0 0127.9 27.9C25.01 30.85 20.506 31.97 16 32c-4.506-.03-9.011-1.151-11.9-4.1a11.187 11.187 0 01-1.597-1.978c2.905-.969 7.732-1.602 13.195-1.602 5.783 0 10.853.71 13.686 1.776z",
    fill: "#7F0119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.76 14.4a5.76 5.76 0 11-11.52 0 5.76 5.76 0 0111.52 0z",
    fill: "#FFB500"
  }));
};

IconIllustrativeRecommendation.propTypes = process.env.NODE_ENV !== "production" ? {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
export default IconIllustrativeRecommendation;
//# sourceMappingURL=IconIllustrativeRecommendation.js.map